































import { Component, Prop, Ref, Vue, Watch } from 'vue-property-decorator'
import parse from 'date-fns/parse'
import format from 'date-fns/format'

@Component
export default class TimeInput extends Vue {
  @Ref()
  private pickerMenu!: any

  @Prop({ required: true })
  private value!: string

  @Prop({ default: 'HH:mm' })
  private format!: string

  private menu = false
  private model = this.formatTime(this.value)

  @Watch('value')
  private valueChanged(val: string) {
    this.model = this.formatTime(val)
  }

  @Watch('model')
  private modelChanged() {
    this.$emit('input', this.model)
  }

  private formatTime(val: string) {
    if (val) {
      const date = parse(val, this.format, new Date())
      return format(date, this.format)
    }
    return ''
  }
}
